import { render, staticRenderFns } from "./dialog-group-offline.vue?vue&type=template&id=0b62799a&"
import script from "./dialog-group-offline.vue?vue&type=script&lang=js&"
export * from "./dialog-group-offline.vue?vue&type=script&lang=js&"
import style0 from "./dialog-group-offline.vue?vue&type=style&index=0&id=0b62799a&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports